import { useTranslation } from 'react-i18next'
import { BrandMark } from '@clari/ui'
import type { CardDto } from '@/lib/types'

function statusKey(status: string): string {
  return `cards.status_${status}`
}

export function CardPreview({ card }: { card: CardDto }) {
  const { t } = useTranslation('banking')
  const statusLabel = t(statusKey(card.status), { defaultValue: card.status })
  const expiry = `${String(card.expiry_month).padStart(2, '0')}/${String(card.expiry_year).slice(-2)}`

  return (
    <div className="relative flex aspect-[1.586] w-full max-w-sm flex-col justify-between rounded-2xl border border-border bg-bg-subtle p-5">
      <div className="flex items-center justify-between">
        <BrandMark size={18} />
        <span className="text-xs text-text-muted">{t('cards.virtual')}</span>
      </div>
      <div className="font-mono text-lg" aria-label={t('cards.pan_aria', { last4: card.masked_pan })}>
        {/* eslint-disable-next-line i18next/no-literal-string -- masking glyph, not translatable */}
        <span aria-hidden="true">•••• {card.masked_pan}</span>
      </div>
      <div className="flex items-center justify-between text-xs text-text-muted">
        <span>{expiry}</span>
        <span>{statusLabel}</span>
      </div>
      {card.status !== 'enabled' ? (
        <div className="absolute inset-0 flex items-center justify-center rounded-2xl bg-bg/70 text-sm font-medium">
          {statusLabel}
        </div>
      ) : null}
    </div>
  )
}
